import { BooleanInput, FormDataConsumer, NumberInput, SimpleForm, TextInput, required, useEditContext, useGetIdentity, useTranslate } from "react-admin"
import { Box, Typography } from "@mui/material"
import { AddNumberRangeCommand } from "../GeneratedClients/FreeBillApi"
import FormCard from "../inputFormComponents/FormCard"
import FormRow from "../inputFormComponents/FormRow"
import Form from "../inputFormComponents/Form"
import numberRangeValidator from "./numberRangeValidator"
import FormDescription from "../inputFormComponents/FormDescription"
import numberRangeValueValidator from "./numberRangeValueValidator"


interface IProps {
  handleSubmit?: (fieldValues: AddNumberRangeCommand) => void
  name?: string
  context?: "edit" | "create"
}

const FormInput = ({handleSubmit, name, context}: IProps) => {
  
  const translate = useTranslate()
  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  const { record: numberRange, isLoading: numberRangeLoading} = useEditContext()

  if(identityLoading || !identity || numberRangeLoading) return null

  const cards = (formData: any) => [
    <FormCard 
      title={translate("Nummernkreis für die Rechnungsnummer definieren")} 
      rows={[
        <FormRow fields={[
            <TextInput fullWidth helperText={"Eindeutiger Name für diesen Nummernkreis"} source="name" validate={[required(), (string:string) => numberRangeValidator(string, numberRange?.id)]} label="resources.numberRanges.title" />,
            <TextInput 
              sx={{ml:2}} 
              fullWidth 
              helperText={"Fester Teil der Rechnungsnummer"} 
              source="value" 
              defaultValue={""} 
              label="resources.numberRanges.value" 
              parse={value => value!==null ? value : ""} 
              validate={[(string:string) => numberRangeValidator(string, numberRange?.id), numberRangeValueValidator]} 
            />,
            <NumberInput sx={{ml:2}} fullWidth helperText={"Start der hoch zählenden Nummer"} source="firstNumber" label="resources.numberRanges.firstNumber" validate={required()} />,
          ]} 
        />,
        <FormRow fields={[
          <BooleanInput helperText={"Wird bei Rechnungserstellung standardmäßig ausgewählt"} source="isDefault" label="resources.numberRanges.isDefault" />
        ]} />
      ]} 
      description={<FormDescription paragraphs={[
        <Box>
          <Typography variant="body1">Vorschau Rechnungsnummer: <strong>{formData.value}{formData.firstNumber}</strong></Typography>
        </Box>,
        <Box>
          <Typography variant="body1">Zusammensetzung der Rechnungsnummer:</Typography>
          <Typography variant="body2">Die Rechnungsnummer besteht aus einem festen Teil (Prefix, kann auch leer bleiben) und einer hoch zählenden Nummer. Beim Erstellen einer neuen Rechnung mit dem gleichen Nummerkreis wird die Rechnungnummer automatisch hoch gezählt. Der feste Teil bleibt gleich.</Typography>
        </Box>,
        <Box>
          <Typography variant="body1">Wichtig:</Typography>
          <Typography variant="body2">Der feste Teil (Prefix) darf nicht mit einer Zahl enden, da die Rechnungsnummer sonst nicht fortlaufend hoch zählen.</Typography>
        </Box>
      ]}/>}
    />
  ]
  
  return (
    <SimpleForm defaultValues={{userId: identity.id, name: name, firstNumber: 1, isDefault: true}} onSubmit={handleSubmit}>
      <FormDataConsumer>
        {({formData}) => {
          return (
            <Form cards={cards(formData)} />
          )
        }}
      </FormDataConsumer>
    </SimpleForm>
  )
}

export default FormInput